import React, { useState, useMemo } from 'react'
import { Typography } from '@material-ui/core'
import { Add as AddIcon } from '@material-ui/icons'
import ServicePicker from './ServicePicker'

const fmt = (v) => '$' + (v || 0).toLocaleString('en-US', { minimumFractionDigits: 0 })

// Project lifecycle order — matches ServicePicker
// Project lifecycle order — matches ServicePicker
const CATEGORY_ORDER = [
  'General', 'Demo', 'Earthwork', 'Irrigation',
  'Hardscape', 'Planting', 'Lighting', 'Water Feature'
]

const ServiceSidebar = ({
  projectServices, services, selectedServiceId, onSelectService,
  onServiceAdded, onServiceRemoved, projectId, url
}) => {
  const [pickerOpen, setPickerOpen] = useState(false)

  const grouped = useMemo(() => {
    const groups = {}
    for (const ps of (projectServices || [])) {
      const cat = ps.serviceCategory || 'Other'
      if (!groups[cat]) groups[cat] = []
      groups[cat].push(ps)
    }
    // Sort by lifecycle order
    const sorted = {}
    CATEGORY_ORDER.forEach(cat => { if (groups[cat]) sorted[cat] = groups[cat] })
    Object.keys(groups).forEach(cat => { if (!sorted[cat]) sorted[cat] = groups[cat] })
    return sorted
  }, [projectServices])

  const projectTotal = useMemo(() => {
    return (projectServices || []).reduce((sum, ps) => sum + (ps.totalSell || 0), 0)
  }, [projectServices])

  const projectCost = useMemo(() => {
    return (projectServices || []).reduce((sum, ps) => sum + (ps.totalCost || 0), 0)
  }, [projectServices])

  return (
    <div style={{ width: 260, minWidth: 260, background: '#fff', borderRight: '1px solid #e0e0e0', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {/* Project totals */}
      <div style={{ padding: '12px 16px', background: '#1b5e20', color: '#fff' }}>
        <div style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: 1, opacity: 0.7 }}>Project Total</div>
        <div style={{ fontSize: 20, fontWeight: 700, margin: '4px 0' }}>{fmt(projectTotal)}</div>
        <div style={{ fontSize: 10, opacity: 0.7 }}>
          {(projectServices || []).length} service{(projectServices || []).length !== 1 ? 's' : ''} · Cost: {fmt(projectCost)}
        </div>
      </div>

      {/* Add services button */}
      <div style={{ padding: '8px 12px', borderBottom: '1px solid #eee' }}>
        <div
          onClick={() => setPickerOpen(true)}
          style={{
            background: '#e8f5e9', border: '1px dashed #4caf50', borderRadius: 6,
            padding: 8, textAlign: 'center', cursor: 'pointer', color: '#2e7d32',
            fontSize: 11, fontWeight: 600
          }}
        >
          <AddIcon style={{ fontSize: 14, verticalAlign: 'middle', marginRight: 4 }} />
          Add Services
        </div>
      </div>

      {/* Service list */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {Object.entries(grouped).map(([category, svcs]) => (
          <div key={category}>
            <div style={{
              padding: '8px 12px 4px', fontSize: 10, fontWeight: 700,
              textTransform: 'uppercase', color: '#888', letterSpacing: 0.5,
              borderBottom: '1px solid #f5f5f5'
            }}>
              {category}
            </div>
            {svcs.map(ps => {
              const isSelected = ps._id === selectedServiceId
              const hasPrice = (ps.totalSell || 0) > 0
              return (
                <div
                  key={ps._id}
                  onClick={() => onSelectService(ps._id)}
                  style={{
                    padding: '8px 12px', margin: '2px 0', cursor: 'pointer',
                    borderLeft: isSelected ? '3px solid #2e7d32' : '3px solid transparent',
                    backgroundColor: isSelected ? '#f1f8e9' : 'transparent'
                  }}
                >
                  <div style={{ fontWeight: 600, fontSize: 12 }}>{ps.serviceName}</div>
                  <div style={{ color: '#666', fontSize: 10 }}>
                    {(ps.areas || []).length} area{(ps.areas || []).length !== 1 ? 's' : ''} · {ps.totalQuantity || 0} {ps.unit || ''} ·{' '}
                    <span style={{ color: hasPrice ? '#2e7d32' : '#ff9800', fontWeight: 600 }}>
                      {hasPrice ? fmt(ps.totalSell) : '$0 — needs pricing'}
                    </span>
                  </div>
                </div>
              )
            })}
          </div>
        ))}
        {(projectServices || []).length === 0 && (
          <div style={{ padding: 20, textAlign: 'center' }}>
            <Typography variant="body2" color="textSecondary">
              No services yet. Click "Add Services" to get started.
            </Typography>
          </div>
        )}
      </div>

      <ServicePicker
        open={pickerOpen}
        onClose={() => setPickerOpen(false)}
        services={services}
        projectServices={projectServices}
        projectId={projectId}
        url={url}
        onServiceAdded={onServiceAdded}
        onServiceRemoved={onServiceRemoved}
      />
    </div>
  )
}

export default ServiceSidebar
